import dex from './dex'
import points from './points'
import rebate from './rebate'
export default {
  home: {
    app: 'Memeshot',
    title: "Memeshot.com , that's the meme.",
    subTitle: 'Bir meme coin bul, dene, kârını al. İşte bu kadar',
    inviteFriends: 'Profesyonellere katılın, MEME coin’de ',
    inviteTextEnd: ' kat kazanın!',
    appStore: 'App Store',
    testFlight: 'TestFlight',
    googlePlay: 'Google Play',
    android: 'Android',
    scanToDownload: 'İndirmek için tara',
    soon: 'Yakında',
    downloadFrom: 'Buradan indir',
    appDownload: 'Apk İndir',
    joinUs: 'Katıl',
    followUs: 'Bizi takip et',
    learn: 'Öğren',
  },
  referralCenter: {
    inviteFriend:
      'Davet ettiğin kullanıcıların işlem ücretlerinden %30 bonus kazan',
    referralRules: 'Kurallar',
    totalReward: 'Toplam Kazançlarım',
    usdtAmount: '$',
    referralCount: 'Referanslar',
    defaultReferral: 'Komisyon İadem',
    youReceive: 'İade Oranım',
    receiveAmount: '50%',
    referralLink: 'Referans Linki',
    inviteButton: 'Arkadaşlarını Hemen Davet Et!',
    referralOverview: 'Referans Merkezi',
    totalReferralIncome: 'Toplam İadeler ($)',
    totalReferralCount: 'Toplam Referanslar',
    myInvitations: 'Davetlerim',
    myRebates: 'İadelerim',
    userId: 'Kullanıcı ID',
    rebateRate: 'İade Oranı',
    registrationTime: 'Kayıt Zamanı',
    releaseTime: 'Serbest Bırakma Zamanı',
    rebateAmount: 'İade Miktarı',
    status: 'Durum',
    pendingRelease: 'Serbest Bırakılmamış',
    released: 'Serbest Bırakılmış',
    copied: 'Kopyalandı',
    dataDetails: 'Detaylar',
    joinBtn: 'İş Ortaklığı',
    title1: 'Normal Topluluk Üyesi (R)',
    desc1:
      'R, davet ettiği kullanıcıların ödedikleri ücretlerden %10 komisyon alır.',
    title2: 'Altın Topluluk Lideri (G)',
    desc2:
      'G, davet ettiği kullanıcıların ödedikleri ücretlerden %50 komisyon alır.',
    title3: 'Gümüş Topluluk Lideri (S)',
    desc3:
      'G, davet ettiği kullanıcıların ödedikleri ücretlerden %40 komisyon alır.',
    invitation: 'Arkadaşları Davet Et',
    pageTitle: 'Arkadaşları Davet Et',
    pageSubtitle: 'Arkadaşlarınızdan ** kazanın',
    invitationRelationship: 'İlişki',
    rebateRatio: 'Komisyon Oranı',
    inviterID: 'Davetçi ID',
    hash: 'Txid',
    prePage: 'Önceki',
    nextPage: 'Sonraki',
  },
  referralRulesTexts: {
    text0: 'Davet Seviyeleri:',
    text1: 'Altın Topluluk Lideri (G)',
    text2: 'Gümüş Topluluk Lideri (S)',
    text3: 'Normal Topluluk Üyesi (R)',
    text4: 'Komisyon Kuralları:',
    text5: 'Altın Topluluk Lideri (G):',
    text6:
      'Doğrudan davet edilen Gümüş Topluluk Liderlerinden (S) %40 işlem ücreti komisyonu kazanır.',
    text7:
      'Doğrudan davet edilen Normal Topluluk Üyelerinden (R) %50 işlem ücreti komisyonu kazanır.',
    text8:
      'Dolaylı olarak davet edilen Normal Topluluk Üyelerinden (R) %10 işlem ücreti komisyonu kazanır.',
    text9: 'Gümüş Topluluk Lideri (S):',
    text10:
      'Doğrudan davet edilen Normal Topluluk Üyelerinden (R) %40 işlem ücreti komisyonu kazanır.',
    text11: 'Normal Topluluk Üyesi (R):',
    text12:
      'Doğrudan davet edilen diğer Normal Topluluk Üyelerinden (R) %10 işlem ücreti komisyonu kazanır.',
    text13: 'Rol Nasıl Elde Edilir:',
    textRoleTitle1: 'Altın Topluluk Lideri (G):',
    text14:
      "Toplamda 50.000$ komisyon kazanın veya 'İş Ortaklığı' başvurusu yaparak bu rolü elde edin.",
    textRoleTitle2: 'Gümüş Topluluk Lideri (S):',
    text15:
      'Toplamda 30.000$ komisyon kazanın veya bu rol için başvurun, veya Altın Topluluk Lideri (G) tarafından paylaşılan bir davet bağlantısı ile kaydolun.',
    textRole2Text: '',
    textRoleTitle3: 'Normal Topluluk Üyesi (R):',
    text16:
      'Doğrudan kaydolun, veya Altın Topluluk Lideri (G), Gümüş Topluluk Lideri (S) ya da başka bir Normal Topluluk Üyesi (R) tarafından davet alın.',
    text17: 'Komisyon Ödemesi:',
    text18: 'Komisyonlar, toplam miktar 5$ olduğunda ödenir.',
  },
  register: {
    title: 'Memeshot Hesabı Aç',
    account: 'Hesap',
    email: 'E-posta',
    accountPlaceholder: 'E-posta Adresini Gir',
    accountErrMsg: 'Geçersiz e-posta',
    password: 'Şifre',
    passwordPlaceholder: 'Şifreni Gir',
    passwordErrMsg:
      'Şifre en az 3 karakter türü içermeli (küçük, büyük, sayı, özel)',
    passwordErrMsgOne: 'En az 8 karakter',
    passwordErrMsgTwo: '20 karakteri aşmasın',
    passwordErrMsgThree: 'En az bir rakam ve bir harf gerek',
    signIn: 'Giriş Yap',
    signUp: 'Kayıt Ol',
    verifyBtn: 'Kod Al',
    verify: 'Kod',
    verifyDesc: 'Doğrulama Kodunu Gir',
    emailVerify: 'E-posta Doğrulama Kodu',
    emailVerifyPlaceholder: 'Doğrulama Kodunu Gir',
    resend: 'Yeniden Gönder',
    confirm: 'Onayla',
    confirmPassword: 'Şifreyi Onayla',
    confirmPasswordErr: 'Şifreler uyuşmuyor',
    inviteCode: 'Davet Kodu (Opsiyonel)',
  },
  Cancellation: {
    logoffAccount: 'Hesap İptal Başvurusu',
    reason: 'neden',
    reasonCancellation: 'İptal Nedeni',
    applyInTitle: 'İnceleniyor, teşekkürler',
    applyDoneText: 'İptal Başarılı',
    cancelApplyButton: 'Başvuruyu İptal Et',
    submit: 'Gönder',
    cancelApply: 'Başvuruyu İptal Et',
  },
  // 目前只支持英文版
  userAgreement: {
    welcome: 'Thank you for using Memeshot!',
    policyMainText:
      'This Privacy Policy details how we collect, use, disclose, and protect your personal information to ensure your privacy rights. We are committed to complying with data privacy laws and regulations and safeguarding the security of your personal information.',
    part1: '1. Protection of Information',
    part1Text:
      'In the course of using this application, we may protect information including but not limited to the following types:',
    part1_1: '1.1 User Identity Information',
    part1_1Text:
      '- Wallet Address: The blockchain wallet address you create or connect to this application. We do not collect your real identity information.',
    part1_1Text2:
      '- Transaction Records: Necessary on-chain transaction records used to provide services, which do not include any unnecessary personal identification information.',
    part1_2: '1.2 Usage Information',
    part1_2Text:
      '- Application Usage Data: We automatically collect your interaction data with this application, such as page visits, clicks, and browsing behavior, to help us optimize application features and user experience.',
    part1_3: '1.3 Device Information',
    part1_3Text:
      "- Device Identifiers and Operating System: Includes the device's operating system version and unique device identifier, used to ensure the normal operation and security of the application.",
    part2: '2. Use of Information',
    part2Text:
      'We strictly use your information in a legal, proper, and necessary manner in accordance with this Privacy Policy and relevant laws and regulations. The specific purposes are as follows:',
    part2_1:
      '- Providing and Maintaining Services: Processing on-chain transactions to ensure the normal operation of the custodial wallet.',
    part2_2:
      '- Improving User Experience: Continuously optimizing product features and user interfaces by analyzing application usage behaviors.',
    part2_3:
      '- Ensuring Security: Detecting, preventing, and resolving fraud and illegal activities to protect the security of your assets.',
    part3: '3. Sharing of Information',
    part3Text:
      'We do not sell, rent, or share your personal information with any third parties, but we may share your information under the following circumstances:',
    part3_1:
      'Third-Party Service Providers: To provide application functionalities, we may need to share necessary information with trusted third-party partners. These third parties are limited to using your information only within the scope required to provide their services.',
    part3_2:
      'Legal Requirements: Your information may need to be disclosed if required by laws, legal processes, or government requests.',
    part4: '4. Security of Information',
    part4Text:
      'We are committed to protecting the security of your personal information and have implemented reasonable technical and managerial measures to prevent unauthorized access, disclosure, alteration, or destruction of your information. However, the network environment is not 100% secure, so please properly safeguard your wallet keys and other sensitive information.',
    part5: '5. Privacy Protection for Minors',
    part5Text:
      'This application is not intended for minors. If we discover that we have collected personal information from minors, we will take steps to delete the relevant data as soon as possible.',
    part6: '6. Your Rights',
    part6Text:
      'Under applicable data protection laws, you have the right to perform the following actions regarding your information:',
    part6_1:
      'Access, Update, and Deletion: You can access, update, or delete your account information.',
    part6_2:
      'Privacy Settings: You can adjust your privacy settings within the application at any time to manage how your information is collected and used.',
    part7: '7. Changes to the Privacy Policy',
    part7Text:
      'We may update this Privacy Policy from time to time. The updated Privacy Policy will be posted on this page with the effective date indicated. We recommend that you regularly review the Privacy Policy to stay informed about our latest privacy protection measures.',
  },
  dex: dex.tr_TR,
  points: points.tr_TR,
  rebate: rebate.tr_TR,
}
